import { rqtGetCheckCodeImg, rqtGetCheckCodeImgForAppointment } from '@/services/common'
import { createImgObj } from '@/utils/public/file'

export default {
  data() {
    return {
      codeCheckImg: undefined,
      codeUuidKey: undefined,
      isCodeLoading: false
    }
  },
  methods: {
    onFreshCodeClick() {
      this.handleCodeImg()
    },
    handleCodeImg() {
      this.isCodeLoading = true
      rqtGetCheckCodeImg()
        .then(res => {
          this.codeCheckImg = createImgObj(res)
          this.codeUuidKey = res.headers.uuid_key
          this.isCodeLoading = false
        })
        .catch(() => {
          this.isCodeLoading = false
        })
    },
    onFreshCodeClickForAppointment(params) {
      // 类固收产品没有开放日，赋个默认值。 
      if(!params.openDate){
        params.openDate = '9999-09-09'
      }
      this.isCodeLoading = true
      rqtGetCheckCodeImgForAppointment(params).then(res => {
        this.codeCheckImg = createImgObj(res)
        this.codeUuidKey = res.headers.uuid_key
        this.isCodeLoading = false
      }).catch(() => {
        this.isCodeLoading = false
      })
    },
  }
}
